var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlantCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.49 17.63C23.31 14.84 22.18 12.12 20.06 10C17.92 12.14 16.74 14.86 16.51 17.63C17.79 18.31 18.97 19.19 20 20.26C21.03 19.2 22.21 18.32 23.49 17.63ZM20.05 13.19C20.68 14.22 21.12 15.37 21.35 16.57C20.88 16.87 20.44 17.2 20.01 17.55C19.59 17.21 19.14 16.88 18.68 16.58C18.93 15.38 19.39 14.23 20.05 13.19ZM20 23.45C19.18 22.2 18.14 21.11 16.94 20.25C16.81 20.16 16.67 20.09 16.54 19.99C16.67 20.08 16.81 20.16 16.93 20.24C14.98 18.83 12.59 18 10 18C10 23.32 13.36 27.82 18.03 29.49C18.66 29.72 19.32 29.89 20 30C20.68 29.88 21.33 29.71 21.97 29.49C26.64 27.82 30 23.32 30 18C25.82 18 22.15 20.17 20 23.45ZM21.32 27.6C20.88 27.75 20.44 27.87 19.99 27.97C19.55 27.88 19.12 27.76 18.71 27.61C15.42 26.43 13.01 23.62 12.26 20.26C13.36 20.52 14.41 20.97 15.38 21.59L15.36 21.6C15.49 21.69 15.62 21.78 15.75 21.85L15.82 21.89C16.81 22.61 17.66 23.5 18.33 24.54L20 27.1L21.67 24.55C22.36 23.5 23.22 22.6 24.2 21.89L24.27 21.84C24.36 21.79 24.45 21.73 24.54 21.67L24.53 21.65C25.51 21 26.6 20.52 27.74 20.25C26.99 23.62 24.59 26.43 21.32 27.6ZM16.99 20.28C16.97 20.27 16.95 20.25 16.94 20.24C16.94 20.24 16.95 20.24 16.95 20.25C16.96 20.26 16.97 20.27 16.99 20.28Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlantCircle);
export default __webpack_public_path__ + "static/media/ic_plant_circle.b4a955e98e45f24a1b92306d6d7d6d55.svg";
export { ForwardRef as ReactComponent };